import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_SUCCESS,
  FETCH_SETTINGS_FAILED,
  EDIT_SETTINGS,
  CLEAR_SETTINGS_ERROR,
  SHOW_HUD
} from "../store/types";

import store from '../store/store';
import { firebase } from '../config/configureFirebase';
import { onValue, set, update } from "firebase/database";
import { uploadBytesResumable, getDownloadURL, ref as stRef } from "firebase/storage";
import { showHUD } from "./hudactions";

export const fetchSettings = () => (dispatch) => {
  const { settingsRef } = firebase;

  if (!settingsRef) {
    console.warn("[settingsactions] DB not ready (settingsRef null), retrying in 300ms...");
    setTimeout(() => {
      dispatch(fetchSettings());
    }, 300);
    return;
  }

  dispatch({
    type: FETCH_SETTINGS,
    payload: null,
  });
  onValue(settingsRef, (snapshot) => {
    if (snapshot.val()) {
      dispatch({
        type: FETCH_SETTINGS_SUCCESS,
        payload: snapshot.val(),
      });
    } else {
      console.error("FETCH_SETTINGS: Snapshot is empty/null");
      dispatch({
        type: FETCH_SETTINGS_FAILED,
        payload: "Database Empty (No Settings Found)",
      });
    }
  }, (error) => {
    console.error("FETCH_SETTINGS_ERROR:", error);
    dispatch({
      type: FETCH_SETTINGS_FAILED,
      payload: "DB Error: " + error.message,
    });
  });
};

export const editSettings = (settings) => async (dispatch) => {
  const {
    settingsRef
  } = firebase;
  dispatch({
    type: EDIT_SETTINGS,
    payload: settings
  });
  await update(settingsRef, settings);
  dispatch(showHUD(store.getState().languagedata.defaultLanguage.updated, 'success'));
};

export const clearSettingsViewError = () => (dispatch) => {
  dispatch({
    type: CLEAR_SETTINGS_ERROR,
    payload: null
  });
};

export const updateSettingsImage = (imageBlob) => async (dispatch) => {
  const {
    storage,
    settingsRef
  } = firebase;

  const storageRef = stRef(storage, `settings_images/company_logo`);

  await uploadBytesResumable(storageRef, imageBlob);
  const url = await getDownloadURL(storageRef);

  await update(settingsRef, {
    logo: url
  });
  return url;
};

export const editGoogleSettings = (googleSettings) => (dispatch) => {
  const {
    settingsRef
  } = firebase;
  update(settingsRef, {
    google: googleSettings
  });
};